module.exports = __webpack_public_path__ + "static/rich-00354186463149a008a2c714ca419185.png";